export default "__VITE_ASSET__9d43d3a0__"